<template>
  <button class="mdc-icon-button material-icons"
          @click="onClick"
          :title="title">
    <slot/>
  </button>
</template>

<script>
import { MDCRipple } from '@material/ripple'

export default {
  name: 'mdc-icon-button',

  props: {
    title: String
  },

  mounted () {
    this.iconButtonRipple = MDCRipple.attachTo(this.$el)
    this.iconButtonRipple.unbounded = true
  },

  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>
